import React, { Component } from "react";
import { Form, Button, Label, Message } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";

import _ from "lodash";
import PropTypes from "prop-types";

import Aux from "../utility/Aux";

/**
 * LoginForm: Component
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Form component used for login, containing username and
 * password fields
 */
class LoginForm extends Component {
  state = {
    /**
     * Stores current field values
     */
    data: {
      username: "demo",
      password: "Test123!"
    },

    /**
     * True if a login request is currently underway
     */
    isLoading: false,

    /**
     * Contains errors with the affected field as the key and the displayed
     * message or localization key as the value
     */
    errors: {}
  };

  /**
   * Updates the state values whenever a field changes
   */
  onChange = e =>
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value }
    });

  /**
   * Submits the form if it passes validation checks
   */
  onSubmit = () => {
    const errors = this.validate(this.state.data);
    this.setState({ errors });

    if (_.isEmpty(errors)) {
      this.setState({ loading: true });
      this.props.submit(this.state.data).catch(err => {
        this.setState({
          errors: { global: err.response.data.message },
          loading: false
        });
      });
    }
  };

  /**
   * Validates on the client-side if the user-given values make sense
   */
  validate = data => {
    const errors = {};

    if (!data.username) errors.username = "login.error.usernameBlank";
    if (!data.password) errors.password = "login.error.passwordBlank";

    return errors;
  };

  /**
   * Renders the React form component
   */
  render() {
    const { data, errors, loading } = this.state;

    return (
      <Aux>
        <Form onSubmit={this.onSubmit} loading={loading}>
          {/**
           * Conditionally renders a global request error message
           */
          errors.global && (
            <Message negative>
              <p>
                <FormattedMessage id={errors.global} />
              </p>
            </Message>
          )}
          <Form.Field error={!!errors.username}>
            <Label htmlFor="login-username">
              <FormattedMessage
                id="login.fields.username"
                description="Label for username field"
              />
            </Label>
            <input
              type="text"
              id="login-username"
              name="username"
              value={data.username}
              onChange={this.onChange}
            />
            {errors.username && (
              <Message negative>
                <p>
                  <FormattedMessage id={errors.username} />
                </p>
              </Message>
            )}
          </Form.Field>
          <Form.Field error={!!errors.password}>
            <Label htmlFor="login-password">
              <FormattedMessage
                id="login.fields.password"
                description="Label for password field"
              />
            </Label>
            <input
              type="password"
              id="login-password"
              name="password"
              value={data.password}
              onChange={this.onChange}
            />
            {this.state.errors.password && (
              <Message negative>
                <p>
                  <FormattedMessage id={errors.password} />
                </p>
              </Message>
            )}
          </Form.Field>
          <Button primary>
            <FormattedMessage
              id="login.submit"
              description="Login action text for login form button"
            />
          </Button>
        </Form>
      </Aux>
    );
  }
}

LoginForm.propTypes = {
  /**
   * submit: (data) => ()
   * Function called to submit the login form data to the server
   * using the current form data.
   */
  submit: PropTypes.func.isRequired
};

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/loginform/LoginForm.js